// extracted by mini-css-extract-plugin
module.exports = {"root":"FiltroApplicato_root__da5Od","close":"FiltroApplicato_close__1Q28K","rotation":"FiltroApplicato_rotation__bHJEC"};